import React from 'react'

export default function NoPage() {
  return (
    <div>Page not found</div>
  )
}
